module.exports = __webpack_public_path__ + "img/loading--circle.0c44dacf.gif";